import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  split,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getMainDefinition } from "@apollo/client/utilities";
import { Socket as PhoenixSocket } from "phoenix";
import * as AbsintheSocket from "@absinthe/socket";
import { createAbsintheSocketLink } from "@absinthe/socket-apollo-link";

export const authHeader = () => {
  const token = localStorage.getItem("palToken");
  if (!token) return undefined;

  return { authorization: `Bearer ${token}`, accept: 'application/json' };
};

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_BACKEND_API_URL,
});

const phoenixSocket = new PhoenixSocket(process.env.REACT_APP_BACKEND_API_WS!, {
  params: () => {
    return authHeader();
  },
});

const absintheSocket = AbsintheSocket.create(phoenixSocket);
const websocketLink = createAbsintheSocketLink(absintheSocket);

const authLink = setContext(async (_, { headers }) => {
  return {
    headers: {
      ...headers,
      ...authHeader(),
    },
  };
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  authLink.concat(websocketLink),
  authLink.concat(httpLink)
);

export const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});
